import { Model } from '../../api/model';

export class TenantModel extends Model {

    public parent_id: number;

    public children: Array<any>;

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/models/tenant.model.ts